import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Button, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import UsersTable from './usersTable';
import './styles.scss';

class UsersCreation extends Component {
  componentDidMount() {
    const {isUserFromTDE, dealerId} = this.props;
    let status = 'I';

    if (!isUserFromTDE) {
      this.props.fetchUsersRequests({status, dealerId});
    } else {
      status = 'E';
      this.props.fetchUsersRequests({status});
    }
  }

  componentWillUnmount() {
    this.props.clearUserRequests();
  }

  renderLoaderOrUsers = () => {
    const {loading, requestsList, isUserFromTDE, dealerId} = this.props;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <UsersTable
        list={requestsList}
        isUserFromTDE={isUserFromTDE}
        dealerId={dealerId}
      />
    );
  };

  render() {
    const {isUserFromTDE} = this.props;
    const path = !isUserFromTDE ? paths.UsersRequestNew : paths.UsersNew;
    return (
      <div className="user-list-container">
        <div className="title-bar">
          <div className="title">
            <h3>Nuevos Usuarios</h3>
            <div className="title-bar-actions">
              <Button
                primary
                className="toyota-primary"
                as={Link}
                to={path}
              >
                Nuevo Usuario
              </Button>
            </div>
          </div>
        </div>
        <Card raised fluid>
          {this.renderLoaderOrUsers()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealerId': state.session.dealerId,
    'loading': state.usersList.loading,
    'requestsList': state.usersList.requestsList,
    'isUserFromTDE': state.session.isUserFromTDE,
  };
};

const {
  fetchUsersRequests,
  clearUserRequests,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchUsersRequests,
  clearUserRequests,
  navigateTo,
})(UsersCreation);
